export default "__VITE_ASSET__COfTEbgC__"